import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/produccion/notaCobro';
import NotaC from './NotaCobro';


const ms2p = (state) => {
  return {
    ...state.nota_cobro,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(NotaC);
